import React, { useState, useEffect } from 'react'
import { X } from 'lucide-react'
import './styles.scss'

export default function IntakeModal({ isOpen, onClose, onSave, initialData }) {
  const [formData, setFormData] = useState({
    name: '',
    term: 'Fall',
    year: new Date().getFullYear(),
    startDate: '',
    applicationDeadline: '',
    documentDeadline: '',
    i20Deadline: ''
  })

  useEffect(() => {
    if (initialData && isOpen) {
      setFormData({
        ...initialData,
        name: initialData.name || '',
        term: initialData.term || 'Fall',
        year: initialData.year || new Date().getFullYear(),
        startDate: initialData.startDate || '',
        applicationDeadline: initialData.applicationDeadline || '',
        documentDeadline: initialData.documentDeadline || '',
        i20Deadline: initialData.i20Deadline || ''
      })
    } else if (isOpen) {
      setFormData({
        name: '',
        term: 'Fall',
        year: new Date().getFullYear(),
        startDate: '',
        applicationDeadline: '',
        documentDeadline: '',
        i20Deadline: ''
      })
    }
  }, [initialData, isOpen])

  if (!isOpen) return null

  const handleSubmit = (e) => {
    e.preventDefault()
    onSave({ ...formData, active: true })
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content fade-in">
        <div className="modal-header">
          <h2>{initialData ? 'Edit Intake' : 'Add New Intake'}</h2>
          <button className="icon-btn" onClick={onClose}><X size={20} /></button>
        </div>
        
        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label>Intake Name</label>
            <input 
              type="text" 
              required
              placeholder="e.g. Fall 2026"
              value={formData.name}
              onChange={e => setFormData({...formData, name: e.target.value})}
            />
          </div>
          
          <div className="form-row">
            <div className="form-group">
              <label>Term</label>
              <select 
                value={formData.term}
                onChange={e => setFormData({...formData, term: e.target.value})}
              >
                <option value="Fall">Fall</option>
                <option value="Spring">Spring</option>
                <option value="Summer">Summer</option>
                <option value="Winter">Winter</option>
              </select>
            </div>
            <div className="form-group">
              <label>Year</label>
              <input 
                type="number" 
                required
                min="2020"
                max="2100"
                value={formData.year}
                onChange={e => setFormData({...formData, year: e.target.value})}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Start Date</label>
              <input 
                type="date" 
                required
                value={formData.startDate || ''}
                onChange={e => setFormData({...formData, startDate: e.target.value})}
              />
            </div>
            <div className="form-group">
              <label>Application Deadline</label>
              <input 
                type="date" 
                required
                value={formData.applicationDeadline || ''}
                onChange={e => setFormData({...formData, applicationDeadline: e.target.value})}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Document Deadline</label>
              <input 
                type="date" 
                required
                value={formData.documentDeadline || ''}
                onChange={e => setFormData({...formData, documentDeadline: e.target.value})}
              />
            </div>
            <div className="form-group">
              <label>I-20 Deadline</label>
              <input 
                type="date" 
                required
                value={formData.i20Deadline || ''}
                onChange={e => setFormData({...formData, i20Deadline: e.target.value})}
              />
            </div>
          </div>

          <div className="modal-actions">
            <button type="button" className="btn btn-outline" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary">{initialData ? 'Save Changes' : 'Create Intake'}</button>
          </div>
        </form>
      </div>
    </div>
  )
}
